var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-12"},[_c('tinyEditor',{attrs:{"validator":_vm.v.promotion.full_description,"submitted":_vm.submitted},model:{value:(_vm.value.full_description),callback:function ($$v) {_vm.$set(_vm.value, "full_description", $$v)},expression:"value.full_description"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }